"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _autobahnComponents = require("@gcc/autobahn-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDropzone = require("react-dropzone");

var _GenericFileUploadDragNDrop = require("./GenericFileUploadDragNDrop.styles");

/* eslint-disable react/jsx-props-no-spreading */
var GenericFileUploadDragNDrop = function GenericFileUploadDragNDrop(_ref) {
  var acceptedTypes = _ref.acceptedTypes,
      validationHandler = _ref.validationHandler,
      onError = _ref.onError,
      onAccept = _ref.onAccept,
      maxSize = _ref.maxSize,
      imageAsUrl = _ref.imageAsUrl,
      description = _ref.description,
      className = _ref.className;
  var uploadIconUrl = 'https://gcc-ronaele-designbuilder.s3.amazonaws.com/uploadCloud.svg';
  var defaultUploadSvg = 'https://gcc-ronaele-regionalization.s3.amazonaws.com/File_added.svg';
  var mappedTypes = acceptedTypes.reduce(function (obj, item) {
    return Object.assign(obj, (0, _defineProperty2["default"])({}, item, []));
  }, {});

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    accept: mappedTypes,
    onDrop: function onDrop(acceptedFiles, fileRejections) {
      if (fileRejections && fileRejections.length > 0) {
        onError(fileRejections[0].errors[0]);
      } else if (acceptedFiles[0].size / 1000000 > maxSize) {
        onError({
          message: "File size is greater than ".concat(maxSize, " MB")
        });
      } else if (acceptedFiles[0].type.includes('image/')) {
        var img = new Image();
        img.addEventListener('load', function () {
          if (validationHandler(img)) {
            onAccept(acceptedFiles[0], img.src);
          }
        });
        img.src = URL.createObjectURL(acceptedFiles[0]);
      } else if (validationHandler(acceptedFiles[0])) {
        onAccept(acceptedFiles[0], defaultUploadSvg);
      }
    }
  }),
      getInputProps = _useDropzone.getInputProps,
      getRootProps = _useDropzone.getRootProps,
      isFocused = _useDropzone.isFocused,
      isDragAccept = _useDropzone.isDragAccept,
      isDragReject = _useDropzone.isDragReject;

  var prettyTypes = acceptedTypes.map(function (at) {
    return at.split('/')[1].toUpperCase();
  });
  var subContent = "Files Supported: ".concat(prettyTypes.join(', '));

  var imageInput = /*#__PURE__*/_react["default"].createElement("input", getInputProps());

  return /*#__PURE__*/_react["default"].createElement(_GenericFileUploadDragNDrop.DropzoneContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_GenericFileUploadDragNDrop.ImageContainer, getRootProps({
    isFocused: isFocused,
    isDragAccept: isDragAccept,
    isDragReject: isDragReject
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: imageAsUrl || uploadIconUrl,
    alt: "upload icon"
  }), imageInput, imageAsUrl ? /*#__PURE__*/_react["default"].createElement(_GenericFileUploadDragNDrop.MainContent, null, "Your recent upload.", /*#__PURE__*/_react["default"].createElement("em", null, " Upload new file")) : /*#__PURE__*/_react["default"].createElement(_GenericFileUploadDragNDrop.MainContent, null, /*#__PURE__*/_react["default"].createElement("em", null, "Drag and Drop file here")), /*#__PURE__*/_react["default"].createElement(_GenericFileUploadDragNDrop.SubContent, null, subContent), /*#__PURE__*/_react["default"].createElement(_GenericFileUploadDragNDrop.ButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_autobahnComponents.Button, {
    label: imageAsUrl ? 'Change File' : 'Choose File',
    outline: true
  }), /*#__PURE__*/_react["default"].createElement(_GenericFileUploadDragNDrop.SubContent, null, "Maximum size: ".concat(maxSize, "MB")), description && /*#__PURE__*/_react["default"].createElement(_GenericFileUploadDragNDrop.SubContent, null, description))));
};

GenericFileUploadDragNDrop.propTypes = {
  /** A list of accepted mime types for the file dropzone. */
  acceptedTypes: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,

  /** A function used to run validations against the provided file. */
  validationHandler: _propTypes["default"].func,

  /** Callback function invoked when the uploaded file is not accepted. */
  onError: _propTypes["default"].func.isRequired,

  /** Callback function invoked when the upload file is accepted. */
  onAccept: _propTypes["default"].func.isRequired,

  /** Maximum allowed size of the files. in MegaBytes. */
  maxSize: _propTypes["default"].number.isRequired,

  /** Optional URL of image to show as preview in the dropzone. */
  imageAsUrl: _propTypes["default"].string,

  /** Optional description to be placed under the upload button. */
  description: _propTypes["default"].string,

  /** Custom class to be added to the container */
  className: _propTypes["default"].string
};
GenericFileUploadDragNDrop.defaultProps = {
  className: null,
  imageAsUrl: null,
  description: null,
  validationHandler: function validationHandler(file) {
    return file !== null;
  }
};
GenericFileUploadDragNDrop.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GenericFileUploadDragNDrop",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "imageAsUrl": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Optional URL of image to show as preview in the dropzone.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "description": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Optional description to be placed under the upload button.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "validationHandler": {
      "defaultValue": {
        "value": "(file) => file !== null",
        "computed": false
      },
      "description": "A function used to run validations against the provided file.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "acceptedTypes": {
      "description": "A list of accepted mime types for the file dropzone.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "onError": {
      "description": "Callback function invoked when the uploaded file is not accepted.",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onAccept": {
      "description": "Callback function invoked when the upload file is accepted.",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "maxSize": {
      "description": "Maximum allowed size of the files. in MegaBytes.",
      "type": {
        "name": "number"
      },
      "required": true
    }
  }
};
var _default = GenericFileUploadDragNDrop;
exports["default"] = _default;